// extracted by mini-css-extract-plugin
export default {"headerLangImg":"styleOptions_headerLangImg__rqPF6"};